import { Injectable } from '@angular/core';
import _get from 'lodash-es/get';
import { BaseCacheService } from './base-cache.service';

@Injectable()
export class CacheService {
  private componentKey: any;

  constructor(private baseCache: BaseCacheService) {}

  setComponentKey(key: any): void {
    this.componentKey = key;
  }

  set(objectWithKeys: Record<string, any>): void;
  set<T>(key: string, value: T): void;
  set<T>(keyOrObject: string | Record<string, any>, value?: T): void {
    this.throwEmptyComponentKey();

    const store = this.baseCache.get<Object>(this.componentKey) || {};

    if (typeof keyOrObject === 'object' && keyOrObject !== null) {
      return this.baseCache.set(this.componentKey, {
        ...store,
        ...keyOrObject,
      });
    }

    this.baseCache.set(this.componentKey, {
      ...store,
      [keyOrObject as string]: value,
    });
  }

  get<V>(key: string): V | undefined {
    this.throwEmptyComponentKey();

    const store = this.baseCache.get(this.componentKey);

    return _get(store, key, undefined);
  }

  getAll(): Object | undefined {
    this.throwEmptyComponentKey();

    return this.baseCache.get(this.componentKey);
  }

  remove(key: string): void {
    this.throwEmptyComponentKey();

    const store = this.baseCache.get<Object>(this.componentKey) || {};

    delete store[key];

    this.baseCache.set(this.componentKey, {
      ...store,
    });
  }

  clear(): void {
    this.throwEmptyComponentKey();
    this.baseCache.remove(this.componentKey);
  }

  private throwEmptyComponentKey() {
    if (!this.componentKey) {
      throw new Error('You must provide component key first. Call `setComponentKey()`');
    }
  }
}
